<template>
  <div class="builder__heading">
    <div class="builder__title">
      <h1>
        <span class="builder__title-main">{{ product.title }}</span>
        <span v-if="product.subtitle" class="builder__title-sub">- {{ product.subtitle }}</span>
        <span v-for="add in titleAdditions" :key="add" class="builder__title-add"> | {{ add }}</span>
      </h1>
    </div>
    <div class="builder__price" v-html="price"></div>
  </div>
</template>

<script>
  export default {
    name: 'builder-heading',
    props: [
      'price',
      'product',
      'titleAdditions',
    ],
  }
</script>



// WEBPACK FOOTER //
// Heading.vue?66d454ca